import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

class SrMonthlyFlicker extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onMonthUpdated: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['small', 'regular']),
    limitDate: PropTypes.string,
  };

  constructor() {
    super();

    this.state = {
      currentDate: momentWithAustinTimezone().toISOString(),
    };
  }

  _onNextMonthClicked = () => {
    const {
      onMonthUpdated,
    } = this.props;
    const {
      currentDate,
    } = this.state;

    const nextMonthStartOf = momentWithAustinTimezone(currentDate)
      .startOf('month').add(1, 'months').startOf('month');
    const nextMonthEndOf = momentWithAustinTimezone(currentDate)
      .startOf('month').add(1, 'months').endOf('month');

    onMonthUpdated(
      nextMonthStartOf.toISOString(),
      nextMonthEndOf.toISOString()
    );
    this.setState({
      currentDate:  momentWithAustinTimezone(currentDate)
        .add(1, 'months').toISOString(),
    });
  };

  _onPreviousMonthClicked = () => {
    const {
      onMonthUpdated,
    } = this.props;
    const {
      currentDate,
    } = this.state;

    const previousMonthStartOf = momentWithAustinTimezone(currentDate)
      .startOf('month').subtract(1, 'months').startOf('month');
    const previousMonthEndOf = momentWithAustinTimezone(currentDate)
      .startOf('month').subtract(1, 'months').endOf('month');

    onMonthUpdated(
      previousMonthStartOf.toISOString(),
      previousMonthEndOf.toISOString()
    );
    this.setState({
      currentDate:  momentWithAustinTimezone(currentDate)
        .subtract(1, 'months').toISOString(),
    });
  };

  render() {
    const {
      title,
      type,
      limitDate,
      canSwitchMonths = true,
    } = this.props;
    const {
      currentDate,
    } = this.state;

    let isPreviousLinkActive = true;
    const currentMonth = momentWithAustinTimezone(currentDate).format('MMMM');
    const previousMonthDate = momentWithAustinTimezone(currentDate).subtract(1, 'M').startOf('month');
    const limitDateMoment = momentWithAustinTimezone(limitDate).startOf('month');

    if (limitDate && previousMonthDate.isSame(limitDateMoment)) {
      isPreviousLinkActive = false;
    }

    return (
      <div className={classnames(
        'SrMonthlyFlicker',
        { small: type === 'small' }
      )}
      >
        {canSwitchMonths && (
          <span
            className={classnames(
              'actionLink left',
              { inactive: !isPreviousLinkActive }
            )}
            onClick={() => this._onPreviousMonthClicked(currentDate)}
          />
        )}
        <div className={classnames(
          'titleContainer',
          { fullFlex: !canSwitchMonths }
        )}
        >
          {type === 'small'
            ? (
              <span className='title small'>{title}:&nbsp;
                <span className='month'>{currentMonth.toLowerCase()}</span>
              </span>
            )
            : <span className='title'>{`${title}: ${currentMonth}`}</span>
          }
        </div>
        {canSwitchMonths && (
          <span
            className='actionLink right'
            onClick={() => this._onNextMonthClicked(currentDate)}
          />
        )}
      </div>
    );
  }
}

SrMonthlyFlicker.displayName = 'SrMonthlyFlicker';

export default SrMonthlyFlicker;
